export const FETCH_DOWNLOAD_TEMPLATE_REQUEST = "FETCH_DOWNLOAD_TEMPLATE_REQUEST";
export const FETCH_DOWNLOAD_TEMPLATE_SUCCESS = "FETCH_DOWNLOAD_TEMPLATE_SUCCESS";
export const FETCH_DOWNLOAD_TEMPLATE_FAILURE = "FETCH_DOWNLOAD_TEMPLATE_FAILURE";
